export const DateAndTimeShort = "DD/MM/YYYY HH:mm";
